module.exports = __webpack_public_path__ + "img/cent-sartoro.49d50d23.jpg";